import React, { useContext, useState } from 'react';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import TicketingConfigurationContainer from '@totem/components/ticketing/configuration/ticketingConfigurationContainer';
import MergeTicketsButton from '@totem/components/ticketing/listContainer/MergeTicketsButton';
import TicketExportButton from '@totem/components/ticketing/listContainer/TicketExportButton';
import TicketListContainer, {
  containerConfiguration,
} from '@totem/components/ticketing/listContainer/TicketListContainer';
import TicketListContainerTable from '@totem/components/ticketing/listContainer/TicketListContainerTable';
import TicketEntryDialog from '@totem/components/ticketing/ticket/ticketEntryDialog';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

import '../ticketing.css';

const TicketsPage = () => {
  const { userProfile } = useContext(UserProfileContext);
  const [refreshRequested, setRefreshRequested] = useState<boolean>(false);
  const [showNewTicketModal, setShowNewTicketModal] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const handleTicketCreateClosed = (ticketCreated: boolean) => {
    setShowNewTicketModal(false);
    if (ticketCreated) {
      setRefreshRequested(true);
    }
  };

  const refreshAcknowledged = () => {
    setRefreshRequested(false);
  };

  return (
    <ContentLayout>
      <InputContainer
        filterConfig={containerConfiguration}
        defaultSort={{
          field: 'createdAt',
          direction: 'descend',
        }}
        defaultFilters={[
          {
            field: 'status',
            values: ['OPEN', 'RESOLVED'],
          },
        ]}
        componentKey={'dashboard.ticketing'}
      >
        <TicketListContainer
          onRecordTotalChanged={setTotalRecords}
          onDataRefreshRequested={refreshAcknowledged}
          refresh={refreshRequested}
        >
          <TicketingConfigurationContainer>
            <IBCard
              isCovered
              title={'Ticket Management'}
              extra={
                <>
                  <RecordCountBadge count={totalRecords} />
                  {permissions.ticketingAdministrator.hasPermissions(
                    userProfile,
                  ) && (
                    <>
                      &nbsp;&nbsp;&nbsp;
                      <IBTooltip
                        content={permissions.ticketingAdministrator.tooltip}
                      >
                        <MergeTicketsButton />
                      </IBTooltip>
                    </>
                  )}
                  <TicketExportButton />
                  {permissions.ticketingCreator.hasPermissions(
                    userProfile,
                    securityGroupCheckConstraintAny,
                  ) && (
                    <>
                      &nbsp;&nbsp;&nbsp;
                      <IBTooltip content={permissions.ticketingCreator.tooltip}>
                        <Button
                          type="primary"
                          onClick={() => setShowNewTicketModal(true)}
                        >
                          New Ticket
                        </Button>
                      </IBTooltip>
                    </>
                  )}
                </>
              }
            >
              <div styleName="table-chips-container">
                <FilterChips />
              </div>
              <TicketListContainerTable />
            </IBCard>
            {showNewTicketModal && (
              <TicketEntryDialog
                visible={showNewTicketModal}
                onClose={handleTicketCreateClosed}
              />
            )}
          </TicketingConfigurationContainer>
        </TicketListContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default TicketsPage;
